import { useState } from "react";
import { TOSUpdatedMessage } from "./TOSUpdatedMessage";
import { acceptTOS } from "../../firestore/Functions/TOSFunctions";

export function TOSModal({ handleCloseTOSModal } : { handleCloseTOSModal: () => void }) {
    const [ tosAccepted, setTosAccepted ] = useState(false);
    const [ isSubmitting, setIsSubmitting ] = useState(false);

    const handleAcceptTOS = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTosAccepted(e.target.checked);
    }

    const handleContinue = async () => {
        setIsSubmitting(true);
        await acceptTOS();
        handleCloseTOSModal();
        setIsSubmitting(false);
    }


    return (
        <div className="relative z-10 w-[80%] mx-[10%]"
            role="dialog"
            aria-modal="true">
            <div className="fixed inset-0 bg-gray-300 bg-opacity-75 transition-all backdrop-blur-sm"></div>
            <div className="flex justify-center px-2 py-12 text-center ">
                <div className="fixed rounded-2xl bg-white text-black text-left shadow-xl transition-all ">
                    <div className="flex justify-between items-center px-5 py-4 border-b">
                        <h2 className="text-lg font-bold">Terms of Service Updated</h2>
                        <button className="text-gray-600 hover:text-gray-800" aria-label="Close modal">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className="px-5 py-4 text-sm text-gray-600">
                        <br />
                        <TOSUpdatedMessage />
                    </div>
                    <div className="flex px-5 py-4 overflow-y-auto items-center w-full">
                        <input
                            type="checkbox"
                            required
                            checked={tosAccepted}
                            onChange={handleAcceptTOS}
                            className="mr-2"
                        />
                        <label className="text-sm text-gray-600 font-bold w-full">
                            I agree to the <a className="text-indigo-600 hover:underline" href="/userAgreement" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                        </label>
                        <button className="primary-button" disabled={!tosAccepted} onClick={handleContinue}>
                            {isSubmitting ? "Loading..." : "Continue"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}